var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 197,
    viewBox: "0 0 134 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17896 4.17896H128.158V185.834H4.17896V4.17896Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81205 1C4.04986 1 1 4.04986 1 7.81205V189.467C1 193.229 4.04986 196.279 7.81205 196.279H125.888C129.65 196.279 132.7 193.229 132.7 189.467V7.81205C132.7 4.04986 129.65 1 125.888 1H7.81205ZM14.6241 10.5369C12.116 10.5369 10.0827 12.5701 10.0827 15.0782V155.407C10.0827 157.915 12.116 159.948 14.6241 159.948H119.076C121.584 159.948 123.617 157.915 123.617 155.407V15.0782C123.617 12.5701 121.584 10.5369 119.076 10.5369H14.6241Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81205 0.772932C3.92445 0.772932 0.772932 3.92446 0.772932 7.81205V189.467C0.772932 193.354 3.92445 196.506 7.81205 196.506H125.888C129.775 196.506 132.927 193.354 132.927 189.467V7.81205C132.927 3.92445 129.775 0.772932 125.888 0.772932H7.81205Z",
    stroke: "#2A2A2A",
    strokeWidth: 0.454137
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.89ae2da39308e13a1b9988a15bc19a6b.svg";
export { ForwardRef as ReactComponent };